import { BigNumber } from '@ethersproject/bignumber';
import { InfoIcon } from '@silo/ui';
import { asDecimal } from '@silo/utils';
import { SiloAsset } from 'app/queries/decoratedSilo';
import { FC } from 'react';

interface IndicatorProps {
  formError?: string;
  remainingAmount: BigNumber | null;
  selectedAsset: SiloAsset;
}

export const Indicator: FC<IndicatorProps> = ({ formError, remainingAmount, selectedAsset: { symbol, decimals } }) => {
  if (formError) {
    return (
      <div className="flex gap-2 text-red-400">
        <span>
          <InfoIcon className="w-4 h-4 mt-0.5" />
        </span>
        <p className="text-sm">{formError}</p>
      </div>
    );
  }

  if (remainingAmount) {
    return (
      <div className="flex gap-2 text-white">
        <span>
          <InfoIcon className="w-4 h-4 mt-0.5" />
        </span>
        <p className="text-sm">
          After this withdrawal you will still have {asDecimal({ bigNumber: remainingAmount, decimals })} {symbol}{' '}
          deposited.
        </p>
      </div>
    );
  }

  return <></>;
};
